// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"3":"f7d315dd","18":"24d59d48","22":"f2cf3f68"}[chunkId] + ".js";
};